import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'

import { BUKTI_KARYA_CATEGORIES } from 'app/ProfileRevampPage/constants'
import { useBackButton } from 'app/ProfileRevampPage/hooks/useBackButton'
import { capitalizeEachWords } from 'utils/text'

const Header = () => {
  const router = useRouter()
  const category = router.query?.category as string
  const { onClickBack } = useBackButton()

  return (
    <HeaderBar fixed>
      <HeaderBarLeftAction onClick={onClickBack} />
      <HeaderBarTitle
        data-testid="profile-bukti-karya-header-title"
        className="capitalize"
      >
        {BUKTI_KARYA_CATEGORIES?.[category]?.title ??
          capitalizeEachWords(category.replace(/_/g, ' '))}
      </HeaderBarTitle>
    </HeaderBar>
  )
}

export default Header
